/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
/* eslint no-unused-vars: 0 */

export enum FileTypes {
  abnSig = 'abnSig',
  aobSig1 = 'aobSig1',
  aobSig2 = 'aobSig2',
  consentSig = 'consentSig',
  hipaaSig = 'hipaaSig',
  patientSig = 'patientSig',
  witness1 = 'witness1',
  finalVideo = 'finalVideo',
  idFront = 'idFront',
  idBack = 'idBack',
  healthInsuranceFront = 'healthInsuranceFront',
  healthInsuranceBack = 'healthInsuranceBack',
  insuranceABNSig = 'insuranceABNSig',
  livingWill = 'livingWill',
  medicareABNSig = 'medicareABNSig',
  medicareFront = 'medicareFront',
  medicareBack = 'medicareBack',
  medicareFront2 = 'medicareFront2',
  medicareBack2 = 'medicareBack2',
  POLST = 'POLST',
  portrait = 'portrait',
  powerOfAttorney = 'powerOfAttorney',
  readerIdFront = 'readerIdFront',
  witness2 = 'witness2',
}

export enum FileName {
  abnSig = 'signature1DataURI',
  aobSig1 = 'signature1DataURI',
  aobSig2 = 'signature2DataURI',
  consentSig = 'signature1DataURI',
  hipaaSig = 'signature1DataURI',
  patientSig = 'signature1DataURI',
  witness1 = 'signature1DataURI',
  finalVideo = 'videoDownloadURI',
  idFront = 'photoIdentificationFrontURI',
  idBack = 'photoIdentificationBackURI',
  healthInsuranceFront = 'healthInsuranceCardFrontURI',
  healthInsuranceBack = 'healthInsuranceCardBackURI',
  insuranceABNSig = 'signature1DataURI',
  livingWill = 'livingWillURI',
  medicareABNSig = 'signature1DataURI',
  medicareFront = 'medicareCardFrontURI',
  medicareBack = 'medicareCardBackURI',
  medicareFront2 = 'medicareCardFrontURI2',
  medicareBack2 = 'medicareCardBackURI2',
  POLST = 'POLSTURI',
  portrait = 'portraitURI',
  powerOfAttorney = 'powerOfAttorneyURI',
  readerIdFront = 'readerIdentificationFrontURI',
  witness2 = 'signature2DataURI',
}

export type ABNSig = {
  signature1DataURI: string;
};
export type AOBSig1 = {
  signature1DataURI: string;
};
export type AOBSig2 = {
  signature2DataURI: string;
};
export type Consent = {
  signature1DataURI: string;
};
export type HIPAA = {
  signature1DataURI: string;
};
export type PatientSig = {
  signature1DataURI: string;
};
export type Witness1 = {
  signature1DataURI: string;
};
export type FinalVideo = {
  videoDownloadURI: string;
};
export type IdFront = {
  photoIdentificationFrontURI: string;
};
export type IdBack = {
  photoIdentificationBackURI: string;
};
export type insuranceABNSig = {
  signature1DataURI: string;
};
export type medicareABNSig = {
  signature1DataURI: string;
};
export type HealthInsuranceFront = {
  healthInsuranceCardFrontURI: string;
};
export type HealthInsuranceBack = {
  healthInsuranceCardBackURI: string;
};
export type LivingWill = {
  livingWillURI: string;
};
export type MedicareFront = {
  medicareCardFrontURI: string;
};
export type MedicareBack = {
  medicareCardBackURI: string;
};
export type MedicareFront2 = {
  medicareCardFrontURI2: string;
};
export type MedicareBack2 = {
  medicareCardBackURI2: string;
};
export type POLST = {
  POLSTURI: string;
};
export type Portrait = {
  portraitURI: string;
};
export type PowerOfAttorney = {
  powerOfAttorneyURI: string;
};
export type ReaderIdentificationFront = {
  readerIdentificationFrontURI: string;
};
export type Witness2 = {
  signature2DataURI: string;
};

export type FileRefObjs =
  | ABNSig
  | AOBSig1
  | AOBSig2
  | Consent
  | HIPAA
  | PatientSig
  | Witness1
  | FinalVideo
  | IdFront
  | IdBack
  | HealthInsuranceFront
  | HealthInsuranceBack
  | LivingWill
  | medicareABNSig
  | MedicareFront
  | MedicareBack
  | POLST
  | Portrait
  | PowerOfAttorney
  | ReaderIdentificationFront
  | Witness2;
